import API from "../utils/api";

export const ACTION_TYPES = {
    CATEGORY_CREATE: 'CATEGORY_CREATE',
    CATEGORY_UPDATE: 'CATEGORY_UPDATE',
    CATEGORY_DELETE: 'CATEGORY_DELETE',
    CATEGORY_FETCH: 'CATEGORY_FETCH',
    CATEGORY_FETCH_ALL: 'CATEGORY_FETCH_ALL',
    CATEGORY_PAGINATION: 'CATEGORY_PAGINATION'
}

export const fetchAll = () => dispatch => {
    API.category().fetchAll()
        .then(res => {
      
            dispatch({
                type: ACTION_TYPES.CATEGORY_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, title = "") => dispatch => {
    API.category().fetchPagination(page, Math.abs(limit), title)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.CATEGORY_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.category().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.CATEGORY_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.category().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.CATEGORY_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {
   
    API.category().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.CATEGORY_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.category().delete(id)
        .then(res =>{
         
            dispatch({
                type: ACTION_TYPES.CATEGORY_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}